import React, { useEffect, useRef } from "react";
/* Components */
import TextArea2 from "../form-elements/TextArea2/textArea2";
import Button from "../button/button";
import { useMutation } from "react-query";
import { fetchChatGPT } from "../../services/chat.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import useChatGPTStore from "../../store/useChatGPT.store";
import useGlobalStore from "../../store/useGlobalStore";
import TextInput2 from "../form-elements/TexInput2/TextInput2";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { MIX_PANEL_EVENTS } from "../../utils/constans";
import useCaseStore from "../../store/useCaseStore";
import { v4 as uuidv4 } from "uuid";
import { getUsage } from "../../services/useCaseUsage.service";
import useUsageStore from "../../store/useUsageStore";
import useSessionStore from "../../store/useSessionStore";

const FormABP = () => {
  const { show } = useSnackbarStore();
  const { sendEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  const { setMessages } = useChatGPTStore();
  // eslint-disable-next-line
  const { gptLoading, setGPTLoading } = useGlobalStore();

  const questions = [
    { order: 1, field: "clase", question: "Clase", default: null },
    { order: 2, field: "grado", question: "Grado", default: null },
    { order: 3, field: "edad", question: "Edades", default: "esperadas según Grado" },
    { order: 4, field: "numEstudiantes", question: "Número estudiantes", default: 25 },
    { order: 5, field: "objetivos", question: "Objetivos", default: null },
    { order: 6, field: "numClases", question: "Cantidad de clases", default: null },
    { order: 7, field: "duracion", question: "Duración de cada clase", default: null },
    {
      order: 8,
      field: "recursos",
      question: "Materiales",
      default: "sin tecnología, para un colegio de bajos recursos",
    },
    {
      order: 9,
      field: "conocimientos",
      question: "Conocimientos previos",
      default: "Inferir según grado y Materia",
    },
    {
      order: 10,
      field: "intereses",
      question: "Intereses",
      default:
        "No conozco a los estudiantes. Incluir actividades para conocer sus intereses y ajustar durante el proyecto",
    },
    {
      order: 11,
      field: "consideraciones",
      question: "Consideraciones",
      default: "Estudiantes con niveles muy diversos",
    },
  ];

  const methods = useForm();
  const { handleSubmit, setValue } = methods;
  const navigate = useNavigate();
  const sessionIdRef = useRef(null);
  const { useCaseList } = useCaseStore();
  const { formObject, setFormObject } = useChatGPTStore();
  const { setUsage } = useUsageStore();
  const { user } = useSessionStore();

  const currentUseCase = useCaseList?.find((e) => e.description === "abp1");
  const useCaseId = currentUseCase ? currentUseCase.id : null;

  const getUsagemutation = useMutation(getUsage, {
    onSuccess: (data) => {
      setUsage({
        total: data?.total,
        limit: data?.limit,
        percentage: data?.usagePercentage,
      });
    },
    onError: () => {},
  });

  const mutation = useMutation(fetchChatGPT, {
    onSuccess: (res) => {
      getUsagemutation.mutate(user?.email);
      sendEvent(MIX_PANEL_EVENTS.abpUseCaseResponse);
      setMessages(res?.messages);
      setGPTLoading(false);
      sendEvent(MIX_PANEL_EVENTS.abpSend);
      navigate(`/interation-abp?sessionId=${sessionIdRef.current}`);
    },
    onError: (err) => {
      if (err.response.status === 403) {
        navigate("/");
      } else {
        show("Ocurrio un error, vuelve a intentar", "error");
      }
      setGPTLoading(false);
    },
  });

  const onSubmit = (formData) => {
    const prepareQuestions = questions.map((e) => ({
      ...e,
      value: formData[e.field],
    }));
    const parsedQuestions = prepareQuestions.map(
      (e) => `${e.question}: ${!e.value && e.default ? e.default : e.value}`
    );
    const content = `contextoUsuario: ${parsedQuestions.join("  ")}`;
    setGPTLoading(true);
    sessionIdRef.current = uuidv4();
    mutation.mutate({
      messages: [{ role: "user", content }],
      type: "abp1",
      lang: i18n.language,
      session_id: sessionIdRef.current,
      use_case_id: useCaseId,
    });
  };

  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.abpUseCaseView);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (formObject.length) {
      formObject.forEach((element) => {
        setValue(element.field, element.value);
      });
    }
    // eslint-disable-next-line
  }, [formObject]);

  useEffect(
    () => {
      return () => {
        setFormObject([]);
      };
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-row">
            <TextInput2
              label={t("formulario_abp_campo_clase_label")}
              labelInstruction={t("formulario_abp_campo_clase_instruction")}
              name="clase"
              placeHolder={t("formulario_abp_campo_placeholder_clase_area")}
              maxLength={"50"}
              required
            />

            <TextInput2
              label={t("formulario_abp_campo_grado_label")}
              labelInstruction={t("formulario_abp_campo_grado_instruction")}
              name="grado"
              placeHolder={t("formulario_abp_campo_placeholder_grado_nivel")}
              maxLength={"20"}
              required
            />
          </div>
          <div className="input-row">
            <TextInput2
              label={t("formulario_abp_campo_edades_label")}
              labelInstruction={t("formulario_abp_campo_edades_instruction")}
              name="edad"
              placeHolder={t("formulario_abp_campo_placeholder_rango_edad")}
              maxLength={"20"}
            />

            <TextInput2
              label={t("formulario_abp_campo_numero_estudiantes_label")}
              labelInstruction={t(
                "formulario_abp_campo_numero_estudiantes_instruction"
              )}
              name="numEstudiantes"
              placeHolder={t(
                "formulario_abp_campo_placeholder_numero_estudiante"
              )}
              maxLength={"20"}
            />
          </div>

          <TextArea2
            label={t("formulario_abp_campo_objetivos_estandares_label")}
            labelInstruction={t(
              "formulario_abp_campo_objetivos_estandares_instruction"
            )}
            name="objetivos"
            placeholder={t(
              "formulario_abp_campo_placeholder_objetivos_aprendizaje"
            )}
            maxLength={"2000"}
            required
          />

          <TextInput2
            label={t("formulario_abp_campo_num_clases_label")}
            labelInstruction={t("formulario_abp_campo_num_clases_instruction")}
            name="numClases"
            placeHolder={t("formulario_abp_campo_num_clases_placeholder")}
            maxLength={"20"}
            required
          />

          <TextInput2
            label={t("formulario_abp_campo_duracion_label")}
            labelInstruction={t("formulario_abp_campo_duracion_instruction")}
            name="duracion"
            placeHolder={t("formulario_abp_campo_placeholder_duracion")}
            maxLength={"20"}
            required
          />

          <TextArea2
            label={t("formulario_abp_campo_previo_conocimiento_label")}
            labelInstruction={t(
              "formulario_abp_campo_previo_conocimiento_instruction"
            )}
            name="conocimientos"
            placeholder={t(
              "formulario_abp_campo_placeholder_previo_conocimiento"
            )}
            maxLength={"2000"}
          />

          <TextArea2
            label={t("formulario_abp_campo_recursos_label")}
            labelInstruction={t("formulario_abp_campo_recursos_instruction")}
            name="recursos"
            placeholder={t("formulario_abp_campo_placeholder_recursos")}
            maxLength={"500"}
          />

          <TextInput2
            label={t("formulario_abp_campo_intereses_estudiantes_label")}
            labelInstruction={t(
              "formulario_abp_campo_intereses_estudiantes_instruction"
            )}
            name="intereses"
            placeHolder={t("formulario_abp_campo_placeholder_previo_intereses")}
            maxLength={"500"}
          />

          <TextArea2
            label={t("formulario_abp_campo_otras_consideraciones_label")}
            labelInstruction={t(
              "formulario_abp_campo_otras_consideraciones_instruction"
            )}
            name="consideraciones"
            placeholder={t(
              "formulario_abp_campo_placeholder_previo_consideraciones"
            )}
            maxLength={"500"}
          />

          <div className="form-CTA">
            <Button
              label={
                gptLoading ? `${t("creating")}...` : t("formulario_abp_boton")
              }
              variant="primary"
              typeB="submit"
              disabled={gptLoading}
            />
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default FormABP;
